"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiMenuItem = {
    styleOverrides: {
        root: {
            '&:hover': {
                backgroundColor: colors_1.default.lightOrange,
            },
            '&.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 0, 0.14)',
                '&:hover': {
                    backgroundColor: colors_1.default.lightOrange,
                },
                '&:focus': {
                    backgroundColor: colors_1.default.lightOrange,
                },
            },
        },
    },
};
exports.default = muiMenuItem;
//# sourceMappingURL=muiMenuItem.js.map